import CryptoJS from "crypto-js";
import _ from "lodash";
// import { AuthConfig, AppConfig } from "../Config/AppConfig";
import { AuthConfig, AppConfig } from "../Config/AppConfig";
import { logger } from "./Logger";
import { queryClient } from "../../app/config/queryClient";

const ACCESS_TOKEN_KEY = "@accessToken";
const REFRESH_TOKEN_KEY = "@refreshToken";
const KEYCREDENTIAL_KEY = "@keyCredential";
const IS_FIRST_LAUNCH = "@firstLogin";

// Store in async-storage
const STORE_APP = "app";
// Store in keychain
// persist even app is deleted!
const STORE_KEYCHAIN = "keychain";

// 토큰 저장
export const storeUserCredential = async (userInfo) => {
  try {
    if (AppConfig.storeType === STORE_APP) {
      console.log('[CredentialStorage] Storing credentials:', {
        hasToken: !!userInfo.token,
        hasRefreshToken: !!userInfo.refreshToken,  // ✅ camelCase로 변경
        hasUserId: !!(userInfo.userId || userInfo.id)
      });

      const encryptedToken = CryptoJS.AES.encrypt(userInfo.token, AppConfig.secretKey).toString();
      const encryptedRefreshToken = CryptoJS.AES.encrypt(
        userInfo.refreshToken || "",  // ✅ camelCase로 변경
        AppConfig.secretKey
      ).toString();
      const encryptedKeyCredential = CryptoJS.AES.encrypt(
        userInfo.userId || userInfo.id || "",
        AppConfig.secretKey
      ).toString();

      localStorage.setItem(ACCESS_TOKEN_KEY, encryptedToken);
      localStorage.setItem(REFRESH_TOKEN_KEY, encryptedRefreshToken);
      localStorage.setItem(KEYCREDENTIAL_KEY, encryptedKeyCredential);

      console.log('[CredentialStorage] Credentials stored successfully');
    } else if (AppConfig.storeType === STORE_KEYCHAIN) {
      const tokenSet = {
        token: userInfo.token,
        refreshToken: userInfo.refreshToken,  // ✅ camelCase로 변경
      };
    }
  } catch (err) {
    console.error('[CredentialStorage] Error storing credentials:', err);
  }
};

// 토큰 삭제
export const clearUserCredential = async () => {
  console.log('[CredentialStorage] Clearing user credentials and React Query cache...');

  if (AppConfig.storeType === STORE_APP) {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(KEYCREDENTIAL_KEY);
  } else if (AppConfig.storeType === STORE_KEYCHAIN) {
    // Keychain.resetGenericPassword();
  }

  // ✅ React Query 캐시 초기화
  // 모든 쿼리 캐시를 제거하여 이전 사용자 데이터가 남지 않도록 함
  queryClient.clear();
  console.log('[CredentialStorage] React Query cache cleared successfully');
};

// AccessToken 제공
export const getStoredAccessToken = () => {
  try {
    if (AppConfig.storeType === STORE_APP) {
      const encryptedToken = localStorage.getItem(ACCESS_TOKEN_KEY);
      const token = CryptoJS.AES.decrypt(encryptedToken, AppConfig.secretKey).toString(
        CryptoJS.enc.Utf8
      );

      return _.isEmpty(token) ? null : token;
    } else if (AppConfig.storeType === STORE_KEYCHAIN) {
      // keychain 지원하지 않음
      // await Keychain.setGenericPassword("test@test.com", "12341234");
      // const credentials = await Keychain.getGenericPassword();
      // logger(this, "CREDENTIALS", JSON.stringify(credentials));
      // return JSON.parse(credentials.password).token;
    }
  } catch (err) {
    logger(this, "ANDROID", JSON.stringify(err));
    //logger("CredentialStorage.getAccessToken", err);
  }
};

// // Refresh Token 제공
export const getRefreshToken = async () => {
  try {
    if (AppConfig.storeType === STORE_APP) {
      const encryptedRefreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

      // ✅ 토큰이 없으면 null 반환
      if (!encryptedRefreshToken) {
        console.warn('[CredentialStorage] No refresh token found in localStorage');
        return null;
      }

      const refreshToken = CryptoJS.AES.decrypt(
        encryptedRefreshToken,
        AppConfig.secretKey
      ).toString(CryptoJS.enc.Utf8);

      return _.isEmpty(refreshToken) ? null : refreshToken;
    } else if (AppConfig.storeType === STORE_KEYCHAIN) {
      // const credentials = await Keychain.getGenericPassword();
      // return JSON.parse(credentials.password).refreshToken;
    }
  } catch (err) {
    console.error('[CredentialStorage] Error getting refresh token:', err);
    return null;
  }
};

// Credential Key 제공
export const getKeyCredential = async () => {
  try {
    if (AppConfig.storeType === STORE_APP) {
      const encryptedKeyCredential = localStorage.getItem(KEYCREDENTIAL_KEY);
      const keyCredential = CryptoJS.AES.decrypt(
        encryptedKeyCredential,
        AppConfig.secretKey
      ).toString(CryptoJS.enc.Utf8);
      return _.isEmpty(keyCredential) ? null : keyCredential;
    } else if (AppConfig.storeType === STORE_KEYCHAIN) {
      const credentials = await Keychain.getGenericPassword();
      return credentials.username;
    }
  } catch (err) {
    //logger("CredentialStorage.getKeyCredential", err);
  }
};

// // Check firstLogin
// export const getLaunchCount = async () => {
//   const loaunchCount = await AsyncStorage.getItem(IS_FIRST_LAUNCH);
//   return loaunchCount;
// };

// // Set firstLogin
// export const setLaunchCount = async (arg) => {
//   const count = arg.toString();
//   AsyncStorage.setItem(IS_FIRST_LAUNCH, count).then((result) => {});
// };

// export const removeLaunchCount = async () => {
//   AsyncStorage.removeItem(IS_FIRST_LAUNCH).then(() => {});
// };
// // SNS Login Password create
// export const createSNSLoginPassword = (userInfo) => {
//   return `${userInfo.loginType}${userInfo.id}`;
// };

// export const clearAllCredential = async () => {

// 클럽 채팅 알람 on/off
// await AsyncStorage.removeItem("clubChatNotificationDisabled");
// // 클럽 채팅 정보
// await AsyncStorage.removeItem("clubChatInfo");
// // 알람 설정
// await AsyncStorage.removeItem("alramConf");
// // 최초 로그인
// await AsyncStorage.removeItem("firstLoginTime");
// // 저장된 사용자 프로파일
// await AsyncStorage.removeItem("StoredUserProfile");
// // 클럽 채팅 뱃지 카운트 정보
// await AsyncStorage.removeItem("clubChatCountInfo");
// // 마지막 라이딩 정보
// await AsyncStorage.removeItem("lastRiddenTime");
// // 등록된 블루투스 장치
// await AsyncStorage.removeItem("RegisteredDevice");
// // 등록된 버튼
// await AsyncStorage.removeItem("favoritScreenArray");
// // 유료 사용자 여부
// await AsyncStorage.removeItem("IS_BIKENERD");
// // last ride info
// await AsyncStorage.removeItem("id");
// await AsyncStorage.removeItem("accuracy");
// await AsyncStorage.removeItem("altitude");
// await AsyncStorage.removeItem("altitudeAccuracy");
// await AsyncStorage.removeItem("bearing");
// await AsyncStorage.removeItem("heading");
// await AsyncStorage.removeItem("latitude");
// await AsyncStorage.removeItem("longitude");
// await AsyncStorage.removeItem("speedM");
// await AsyncStorage.removeItem("speedKm");
// await AsyncStorage.removeItem("time");
// await AsyncStorage.removeItem("count");
// await AsyncStorage.removeItem("accSpeedKm");
// await AsyncStorage.removeItem("avgSpeedKm");
// await AsyncStorage.removeItem("maxSpeed");
// await AsyncStorage.removeItem("rideDistance");
// await AsyncStorage.removeItem("lastRiddenTime");
// clearUserCredential;
// };

// Master User 여부 확인
export const isMasterUser = () => {
  try {
    const token = getStoredAccessToken();
    if (!token) {
      return false;
    }

    // JWT 토큰 디코딩
    const payload = JSON.parse(atob(token.split('.')[1]));

    // isMasterUser claim 확인 (문자열 "true" 또는 boolean true)
    return payload.isMasterUser === "true" || payload.isMasterUser === true;
  } catch (error) {
    console.error('[CredentialStorage] Error checking master user status:', error);
    return false;
  }
};

// Tenant Role 가져오기
export const getTenantRole = () => {
  try {
    const token = getStoredAccessToken();
    if (!token) {
      return null;
    }

    // JWT 토큰 디코딩
    const payload = JSON.parse(atob(token.split('.')[1]));

    // role claim 확인
    return payload.role || payload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || null;
  } catch (error) {
    console.error('[CredentialStorage] Error getting tenant role:', error);
    return null;
  }
};

// Access Token 유효성 검사 (만료 시간 확인)
export const isAccessTokenInvalid = () => {
  try {
    const token = getStoredAccessToken();
    if (!token) {
      return true; // 토큰이 없으면 무효
    }

    // JWT 토큰 디코딩
    const payload = JSON.parse(atob(token.split('.')[1]));

    if (!payload.exp) {
      return false; // 만료 시간이 없으면 유효하다고 가정 (또는 정책에 따라 무효)
    }

    // 현재 시간 (초 단위)
    const currentTime = Date.now() / 1000;

    // 만료 시간 (exp) 확인 - 30초 여유를 두고 미리 갱신
    if (payload.exp < currentTime + 30) {
      console.warn('[CredentialStorage] Token is expiring soon or expired:', {
        exp: payload.exp,
        current: currentTime,
        diff: payload.exp - currentTime
      });
      return true;
    }

    return false;
  } catch (error) {
    console.error('[CredentialStorage] Error checking token validity:', error);
    return true; // 파싱 실패 시 무효로 처리
  }
};

export default {
  storeUserCredential,
  // getStoredAccessToken,
  getRefreshToken,
  clearUserCredential,
  getKeyCredential,
  isMasterUser,
  getTenantRole,
  // createSNSLoginPassword,
};
